/**
 * The access ladder a role or permission set holds for an area such as documents or TPRM, lowest first: each level
 * confers the ones below it. The order is load-bearing: pickers list it as is, and the highest-first list below ranks
 * what is held.
 */
export const ACCESS_LEVELS = ['none', 'view', 'edit', 'full'] as const

export type AccessLevel = (typeof ACCESS_LEVELS)[number]

export type GrantedAccessLevel = Exclude<AccessLevel, 'none'>

/** The levels a role or set can hold, highest first: the first one held is the effective level. */
export const GRANTED_ACCESS_LEVELS_HIGHEST_FIRST = ['full', 'edit', 'view'] as const satisfies readonly GrantedAccessLevel[]

/** The effective level: the highest one held. */
export const highestAccessLevel = (isHeld: (level: GrantedAccessLevel) => boolean): AccessLevel =>
  GRANTED_ACCESS_LEVELS_HIGHEST_FIRST.find(isHeld) ?? 'none'
